export default {
    state: {
        isLoggedIn: false,
        user: {
            username: null, avatar: null, initials: null, email: null, permissions: [], roles: [], superuser: false,
            human_user_id: null
        },
    },
    actions: {
        async fetchAuthLogin(ctx, auth) {
            let csrfToken = this._vm.$cookies.get('csrftoken')
            const requestParams = {
                method: "POST",
                credentials: "same-origin",
                redirect: 'follow',
                headers: {
                    // "Content-Type": "application/json",
                    'credentials': "same-origin",
                    'X-CSRFToken': csrfToken,
                },
                body: JSON.stringify({
                    'username': auth.username,
                    'password': auth.password,
                })
            };
            const res = await fetch("/users/login/", requestParams);
            if (!res.ok) {
                const result = await res.json()
                console.log('user', result)
                this._vm.$toast.error("Error:" + JSON.stringify(result.detail), {timeout: 5000})
                return
            }
            const result = await res.json()
            ctx.commit('setLoggedIn', !!result.username)
            ctx.commit('updateUser', result)
        },
        async fetchLoginUser(ctx) {
            const requestParams = {
                method: "GET",
                credentials: "same-origin",
                redirect: 'follow',
                headers: {
                    "Content-Type": "application/json",
                    'credentials': "same-origin",
                },
            };
            const res = await fetch("/users/login_user/", requestParams);
            if (!res.ok) {
                ctx.commit('setLoggedIn', false)
                return
            }
            const result = await res.json()
            ctx.commit('setLoggedIn', !!result.username)
            ctx.commit('updateUser', result)
        },
        async fetchAuthLogout(ctx) {
            let csrfToken = this._vm.$cookies.get('csrftoken')
            const requestParams = {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    'credentials': "same-origin",
                    'X-CSRFToken': csrfToken,
                },
            };
            const res = await fetch("/users/logout/", requestParams);
            if (!res.ok) {
                const result = await res.json()
                this._vm.$toast.error("Error:" + JSON.stringify(result), {timeout: 5000})
                return
            }
            ctx.commit('setLoggedIn', false)
            ctx.commit('updateUser', {username: null, avatar: null, initials: null, email: null, permissions: [], roles: [], superuser: false, human_user_id: null})
        },
        async fetchSetCookie(ctx) {
            const requestParams = {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    'credentials': "same-origin",
                    'X-CSRFToken': '',
                },
            };
            const res = await fetch("/frontend/set_csrf_cookie/", requestParams);
            if (!res.ok) {
                const result = await res.json()
                this._vm.$toast.error("Error:" + JSON.stringify(result), {timeout: 5000})
            }
        },
        async fetchSeLocale(ctx, locale) {
            let csrfToken = this._vm.$cookies.get('csrftoken')
            const data = new FormData();
            data.append('language', locale);
            data.append('next', '/');
            const requestParams = {
                method: "POST",
                headers: {
                    // "Content-Type": "application/json; charset=UTF-8",
                    'credentials': "same-origin",
                    'X-CSRFToken': csrfToken,
                },
                body: data
            };
            const res = await fetch("/i18n/setlang/", requestParams);
            if (!res.ok) {
                const result = await res.json()
                this._vm.$toast.error("Error:" + JSON.stringify(result), {timeout: 5000})
            }
        },
    },
    mutations: {
        setLoggedIn(state, value) {
            state.isLoggedIn = value
        },
        updateUser(state, user) {
            console.log('updateUser', user)
            state.user.username = user.username
            state.user.avatar = user.avatar
            state.user.initials = user.initials
            state.user.email = user.email
            state.user.permissions = user.permissions
            state.user.superuser = user.superuser
            state.user.roles = user.roles
            state.user.human_user_id = user.human_user_id
        }
    },
    getters: {
        getLoggedIn(state) {
            return state.isLoggedIn
        },
        getUser(state) {
            return state.user
        },
    }
}